import { IFactory } from '@app/core/interface/factory';
import { ModelAttributes } from '@app/core/interface/common';

export default class BaseModelFactory implements IFactory {
  protected models: { [key: string]: any };

  /**
   * @description Creates model instance
   * @param {string} shortName
   * @param {ModelAttributes} data
   * @returns {T}
   */
  public create<T>(shortName: string, data: ModelAttributes): T {
    this.checkShortName(shortName);
    return new this.models[shortName](data);
  }

  /**
   * @description Creates several model instances
   * @param {string} shortName
   * @param {ModelAttributes[]} data
   * @returns {T}
   */
  public createMany<T>(shortName: string, data: ModelAttributes[]): T {
    const result: any = [];

    if (Array.isArray(data)) {
      data.forEach((attr: ModelAttributes) => {
        const model = this.create(shortName, attr);
        result.push(model);
      });
    }

    return result;
  }

  /**
   * @description Checks is short name exist in @var models
   * @throws Error
   * @param {string} shortName
   */
  protected checkShortName(shortName: string): void {
    try {
      if (Object.keys(this.models).indexOf(shortName) === -1) {
        throw new Error(
          `Short name not set. Mistype in short name? You typed: ${shortName}`,
        );
      }
    } catch (e) {
      throw new Error(`${e}  short name - ${shortName}`);
    }
  }
}
